import { ActionType } from '../../definitions';
import actionTypes from '../constants/actionTypes';

export const clearSuccess = (payload = {}): ActionType => ({
  type: actionTypes.successes.clear,
  payload,
});
